import React, { Component } from 'react';
import { StyleSheet, Platform, View } from 'react-native';
import ApplePayComponent from './ApplePayComponent';

const ApplePay = (props) => {
	console.log('props', props)
	return <ApplePayComponent {...props} />
};

const styles = StyleSheet.create({

});

export default ApplePay;
